import React, {useEffect} from 'react';
import Apiurl from '../ConstURL';
import {Button, Form, Input, message, Typography, Flex} from 'antd';
import {useNavigate} from "react-router-dom";
import {useAuth} from "../funcs/Authcontext";
import {LockOutlined, UserOutlined} from "@ant-design/icons";

const {Title, Text} = Typography;

export default function Authpage() {
    const Navigate = useNavigate();
    const {user, loginUser} = useAuth();

    useEffect(() => {
        try {
            if (user['Status']) {
                Navigate("/");
            }
        } catch (err) {
        }
    }, []);

    const onFinish = (values) => {
        fetch(Apiurl + "/user/auth?username=" + values.username + "&pass=" + values.password)
            .then(response => response.json())
            .then(data => {
                if (data['Status']) {
                    localStorage.setItem("token", data['Data']);
                    localStorage.setItem("userid", data['Id']);
                    localStorage.setItem("username", values.username);
                    message.success("Авторизация прошла успешно!");
                    loginUser();
                    localStorage.setItem("currentpage", "main");
                    Navigate("main");
                } else {
                    message.error("Неверный логин или пароль!");
                }
            });
    };

    return (
        <div className="login-page">
            <div className="login-card">
                <Flex vertical align="center" gap={8} style={{marginBottom: 32}}>
                    <div className="login-icon">
                        <LockOutlined style={{fontSize: 28, color: '#a017ff'}}/>
                    </div>
                    <Title level={3} style={{margin: 0}}>Zoro Parser</Title>
                    <Text type="secondary">Войдите в свой аккаунт</Text>
                </Flex>

                <Form
                    name="login"
                    size="large"
                    onFinish={onFinish}
                    autoComplete="off"
                    layout="vertical"
                >
                    <Form.Item
                        name="username"
                        rules={[{required: true, message: 'Введите ваш логин!'}]}
                    >
                        <Input
                            prefix={<UserOutlined style={{color: 'rgba(255,255,255,0.3)'}}/>}
                            placeholder="Логин"
                        />
                    </Form.Item>

                    <Form.Item
                        name="password"
                        rules={[{required: true, message: 'Введите ваш пароль!'}]}
                    >
                        <Input.Password
                            prefix={<LockOutlined style={{color: 'rgba(255,255,255,0.3)'}}/>}
                            placeholder="Пароль"
                        />
                    </Form.Item>

                    <Form.Item style={{marginBottom: 0}}>
                        <Button type="primary" htmlType="submit" block>
                            Войти
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </div>
    );
}
